// COA data for all product variants - Janoshik Test Reports
export const COA_DATA = {
  "retatrutide-10mg": {
    taskNumber: "#98201",
    testingOrdered: "15 JAN '26",
    sampleReceived: "20 JAN '26",
    client: "Apollo Compounds",
    sample: "GLP-3R 10mg",
    manufacturer: "Apollo Compounds",
    batch: "AC-R10-0126",
    compoundName: "Retatrutide",
    measuredAmount: "10.34 mg",
    purity: "99.341%",
    analysisDate: "22 JAN 2026",
    verifyKey: "RETGLP10APC01"
  },
  "retatrutide-30mg": {
    taskNumber: "#98202",
    testingOrdered: "15 JAN '26",
    sampleReceived: "20 JAN '26",
    client: "Apollo Compounds",
    sample: "GLP-3R 30mg",
    manufacturer: "Apollo Compounds",
    batch: "AC-R30-0126",
    compoundName: "Retatrutide",
    measuredAmount: "29.64 mg",
    purity: "99.518%",
    analysisDate: "22 JAN 2026",
    verifyKey: "RETGLP30APC02"
  },
  "retatrutide-60mg": {
    taskNumber: "#98203",
    testingOrdered: "15 JAN '26",
    sampleReceived: "20 JAN '26",
    client: "Apollo Compounds",
    sample: "GLP-3R 60mg",
    manufacturer: "Apollo Compounds",
    batch: "AC-R60-0126",
    compoundName: "Retatrutide",
    measuredAmount: "59.42 mg",
    purity: "99.287%",
    analysisDate: "23 JAN 2026",
    verifyKey: "RETGLP60APC03"
  },
  "tirzepatide-10mg": {
    taskNumber: "#98204",
    testingOrdered: "16 JAN '26",
    sampleReceived: "21 JAN '26",
    client: "Apollo Compounds",
    sample: "GLP-2T 10mg",
    manufacturer: "Apollo Compounds",
    batch: "AC-T10-0126",
    compoundName: "Tirzepatide",
    measuredAmount: "10.21 mg",
    purity: "99.456%",
    analysisDate: "23 JAN 2026",
    verifyKey: "TIRGLP10APC04"
  },
  "tirzepatide-15mg": {
    taskNumber: "#98205",
    testingOrdered: "16 JAN '26",
    sampleReceived: "21 JAN '26",
    client: "Apollo Compounds",
    sample: "GLP-2T 15mg",
    manufacturer: "Apollo Compounds",
    batch: "AC-T15-0126",
    compoundName: "Tirzepatide",
    measuredAmount: "15.38 mg",
    purity: "99.372%",
    analysisDate: "23 JAN 2026",
    verifyKey: "TIRGLP15APC05"
  },
  "tirzepatide-30mg": {
    taskNumber: "#98206",
    testingOrdered: "16 JAN '26",
    sampleReceived: "21 JAN '26",
    client: "Apollo Compounds",
    sample: "GLP-2T 30mg",
    manufacturer: "Apollo Compounds",
    batch: "AC-T30-0126",
    compoundName: "Tirzepatide",
    measuredAmount: "30.56 mg",
    purity: "99.611%",
    analysisDate: "24 JAN 2026",
    verifyKey: "TIRGLP30APC06"
  },
  "tirzepatide-60mg": {
    taskNumber: "#98207",
    testingOrdered: "16 JAN '26",
    sampleReceived: "21 JAN '26",
    client: "Apollo Compounds",
    sample: "GLP-2T 60mg",
    manufacturer: "Apollo Compounds",
    batch: "AC-T60-0126",
    compoundName: "Tirzepatide",
    measuredAmount: "60.83 mg",
    purity: "99.193%",
    analysisDate: "24 JAN 2026",
    verifyKey: "TIRGLP60APC07"
  },
  "ghk-cu-50mg": {
    taskNumber: "#98208",
    testingOrdered: "17 JAN '26",
    sampleReceived: "22 JAN '26",
    client: "Apollo Compounds",
    sample: "GHK-Cu 50mg",
    manufacturer: "Apollo Compounds",
    batch: "AC-GC50-0126",
    compoundName: "GHK-Cu",
    measuredAmount: "51.24 mg",
    purity: "99.524%",
    analysisDate: "24 JAN 2026",
    verifyKey: "GHKCU50APC08"
  },
  "ghk-cu-100mg": {
    taskNumber: "#98209",
    testingOrdered: "17 JAN '26",
    sampleReceived: "22 JAN '26",
    client: "Apollo Compounds",
    sample: "GHK-Cu 100mg",
    manufacturer: "Apollo Compounds",
    batch: "AC-GC100-0126",
    compoundName: "GHK-Cu",
    measuredAmount: "101.47 mg",
    purity: "99.412%",
    analysisDate: "25 JAN 2026",
    verifyKey: "GHKCU100APC09"
  },
  "glow-50mg": {
    taskNumber: "#98210",
    testingOrdered: "18 JAN '26",
    sampleReceived: "23 JAN '26",
    client: "Apollo Compounds",
    sample: "Glow Blend 50mg",
    manufacturer: "Apollo Compounds",
    batch: "AC-GL50-0126",
    compoundName: "Glow (BPC-157 / GHK-Cu / TB-500)",
    measuredAmount: "50.63 mg",
    purity: "99.267%",
    analysisDate: "25 JAN 2026",
    verifyKey: "GLOWBL50APC10"
  },
  "glow-70mg": {
    taskNumber: "#98211",
    testingOrdered: "18 JAN '26",
    sampleReceived: "23 JAN '26",
    client: "Apollo Compounds",
    sample: "Glow Blend 70mg",
    manufacturer: "Apollo Compounds",
    batch: "AC-GL70-0126",
    compoundName: "Glow (BPC-157 / GHK-Cu / TB-500)",
    measuredAmount: "71.29 mg",
    purity: "99.389%",
    analysisDate: "26 JAN 2026",
    verifyKey: "GLOWBL70APC11"
  },
  "mots-c-10mg": {
    taskNumber: "#98212",
    testingOrdered: "19 JAN '26",
    sampleReceived: "24 JAN '26",
    client: "Apollo Compounds",
    sample: "MOTS-c 10mg",
    manufacturer: "Apollo Compounds",
    batch: "AC-MC10-0126",
    compoundName: "MOTS-c",
    measuredAmount: "10.17 mg",
    purity: "99.578%",
    analysisDate: "26 JAN 2026",
    verifyKey: "MOTSC10APC12"
  },
  "mots-c-40mg": {
    taskNumber: "#98213",
    testingOrdered: "19 JAN '26",
    sampleReceived: "24 JAN '26",
    client: "Apollo Compounds",
    sample: "MOTS-c 40mg",
    manufacturer: "Apollo Compounds",
    batch: "AC-MC40-0126",
    compoundName: "MOTS-c",
    measuredAmount: "40.82 mg",
    purity: "99.483%",
    analysisDate: "27 JAN 2026",
    verifyKey: "MOTSC40APC13"
  },
  "nad-plus-500mg": {
    taskNumber: "#98214",
    testingOrdered: "20 JAN '26",
    sampleReceived: "25 JAN '26",
    client: "Apollo Compounds",
    sample: "NAD+ 500mg",
    manufacturer: "Apollo Compounds",
    batch: "AC-NAD500-0126",
    compoundName: "NAD+",
    measuredAmount: "503.41 mg",
    purity: "99.628%",
    analysisDate: "27 JAN 2026",
    verifyKey: "NADPL500APC14"
  },
  "semax-10mg": {
    taskNumber: "#98215",
    testingOrdered: "20 JAN '26",
    sampleReceived: "25 JAN '26",
    client: "Apollo Compounds",
    sample: "Semax 10mg",
    manufacturer: "Apollo Compounds",
    batch: "AC-SM10-0126",
    compoundName: "Semax",
    measuredAmount: "10.26 mg",
    purity: "99.714%",
    analysisDate: "28 JAN 2026",
    verifyKey: "SEMX10APC15"
  }
};

export function getCoaKey(slug, mg) {
  return `${slug}-${mg.toLowerCase()}`;
}
